import { BackIcon, Button } from '../atoms';
import { classNames } from 'primereact/utils';

interface TopPageNavigationProps {
  buttonLabel: string;
  handleBack: () => void;
}

export const TopPageNavigation = ({ buttonLabel, handleBack }: TopPageNavigationProps) => {
  return (
    <div className="flex items-center px-6">
      <Button
        text
        label={buttonLabel}
        icon={<BackIcon />}
        onClick={handleBack}
        className={classNames(
          'space-x-1 whitespace-nowrap [&]:px-0.5',
          'hover:[&>span]:text-fletchers-green-900 hover:[&>svg>path]:fill-fletchers-green-900',
          '[&>span]:transition [&>span]:duration-200 [&>span]:ease-in-out',
          '[&>svg>path]:transition [&>svg>path]:duration-200 [&>svg>path]:ease-in-out'
        )}
        aria-label="Go back"
      />
    </div>
  );
};
